import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageCircle, X } from 'lucide-react';
import { CONTACT_PHONE_TEL, WHATSAPP_LINK } from '../utils/constants';

const StickyBar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 300 && !dismissed) setVisible(true);
      else if (window.scrollY <= 300) setVisible(false);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [dismissed]);

  return (
    <AnimatePresence>
      {visible && !dismissed && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 24, stiffness: 260 }}
          className="fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 md:px-8"
        >
          <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-2xl border border-black/8 px-5 py-3 flex items-center justify-between gap-4">
            <p className="text-brand-black font-black text-sm hidden sm:block tracking-tight">
              Ready to ship? <span className="text-brand-orange">Get an instant quote!</span>
            </p>

            <div className="flex items-center gap-3 flex-1 sm:flex-none justify-center sm:justify-end">
              <a
                href={`tel:${CONTACT_PHONE_TEL}`}
                className="flex items-center gap-2 bg-brand-black text-white px-4 py-2.5 rounded-xl text-xs font-black tracking-wider hover:bg-brand-orange transition-all"
              >
                <Phone size={14} /> CALL US
              </a>
              <a
                href={WHATSAPP_LINK('Hi PKRouteX! I need a quick quote.')}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#25D366] text-white px-4 py-2.5 rounded-xl text-xs font-black tracking-wider hover:bg-green-500 transition-all"
              >
                <MessageCircle size={14} /> WHATSAPP
              </a>
              <a
                href="#book"
                onClick={(e) => { e.preventDefault(); document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="flex items-center gap-2 bg-brand-orange text-white px-4 py-2.5 rounded-xl text-xs font-black tracking-wider hover:bg-brand-orange-light transition-all orange-glow"
              >
                BOOK NOW
              </a>
            </div>

            <button onClick={() => setDismissed(true)} className="text-brand-muted hover:text-brand-black transition-colors shrink-0">
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyBar;
